<ng-container *ngIf="issuesData">
  <ng-container *ngFor="let issue of issuesData.items">
    <mat-card class="card">
      <mat-card-header>
        <mat-card-subtitle
          >{{ manageRepoUrl(issue.repository_url) }} #{{ issue.number }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <h3>{{ issue.title }}</h3>
        <div class="justify-between">
          <small class="card-comment"
            >{{ issue.user.login }} opened on
            {{ issue.created_at | date }}</small
          >
          <small class="card-comment"
            >{{ issue.comments }}
            {{ issue.comments === 1 ? "comment" : "comments" }}</small
          >
          <small class="card-comment">status: {{ issue.state }}</small>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
  <app-error [errorData]="issuesData.error"></app-error>
</ng-container>
